import React from 'react';
// @ts-ignore
import styles from './EducationMaterialsFolder.module.scss';
import Collapse from '../HealthPlan/Collapse/Collapse';
import EducationMaterialsItem from './EducationMaterialsItem';
import { EducationMaterialInterface } from '../../Models/EducationMaterials/EducationMaterial';
import { useEffect, useState } from 'react';

interface EducationMaterialsFolderProps {
	data: {
		id: string;
		name: string;
		educationMaterials: [EducationMaterialInterface];
	};
	onUpdateItem: (items) => void;
}

export default function EducationMaterialsFolder(
	props: EducationMaterialsFolderProps,
) {
	const { data, onUpdateItem } = props;

	const [materials, setMaterials] = useState(data.educationMaterials);

	useEffect(() => {
		setMaterials(data.educationMaterials);
	}, [data]);

	const onUpdateMaterial = item => {
		const currentMaterials = [...materials];
		for (const materialIndex in currentMaterials) {
			if (currentMaterials[materialIndex].id === item.id) {
				currentMaterials[materialIndex] = item;
			}
		}

		setMaterials(currentMaterials);
		onUpdateItem({ ...data, educationMaterials: materials });
	};

	if (materials && materials.length) {
		return (
			<div className={styles.item}>
				<Collapse
					title={data.name}
					defaultOpen={true}
					contentClassName={styles.collapseContent}
					icon={'/dist/icons/folder-solid.svg'}>
					<div className='row'>
						{materials &&
							materials.map(item => (
								<div className='col-lg-3 col-sm-4 col-2 mb-3' key={item.id}>
									<EducationMaterialsItem
										item={item}
										onUpdateItem={onUpdateMaterial}
									/>
								</div>
							))}
					</div>
				</Collapse>
			</div>
		);
	}

	return <></>;
}
